import {css} from "@emotion/react";
import React from "react";
import {Dayjs } from "dayjs";
import dayjs from "dayjs";
import { t } from 'i18next';

interface Props {
  highRiskTimes: Dayjs[][];
}

const Container = css`
  margin: 16px 0;
  padding: 8px;
  background-color: #f8f8f8;
  border: 1px solid #ddd;
  display: inline-flex;
  flex-direction: column;
  border-radius: 8px;
`;

const Title = css`
  margin: 0 0 8px 0;
  color: #FF7152;
  font-size: 20px;
`

const Contents = css`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  font-size: 16px;
`

export const HighRiskTimesDisplay = React.memo(
  ({
    highRiskTimes
  }: Props) => {

    const renderHighRiskTimes = (highRiskTimes: Dayjs[][]) => {
      return highRiskTimes.slice()
        .map((time, index) => (
          <span key={index}>
            {time.length == 1 ? (
                <>{time[0].format('HH:mm')}-</>
            ) : (
                <>{time[0].format('HH:mm')} - {time[1].format('HH:mm')}</>
            )}
            {index < highRiskTimes.length - 1 ? ', ' : ''}
          </span>
        ))
    }

    return (
      <div css={Container}>
        <h4 css={Title}>
          {t("@recommendedTimesForSkinCare", "皮膚ケアを推奨する時間帯")}
        </h4>
        <div css={Contents}>
          {renderHighRiskTimes(highRiskTimes)}
        </div>
      </div>
    )
  }
);
